import { appendElement, appendElementIf } from '../xml-helpers';

export interface IsbnInputs {
  electronicIsbn?: string;
  printIsbn?: string;
}

export type NoIsbnReason = 'monograph' | 'simple_series';

export interface IssnInputs {
  onlineIssn?: string;
  printIssn?: string;
}

export function buildDoiData(
  parent: Element,
  doi: string,
  resourceUrl: string
): Element {
  const doiData = appendElement(parent, 'doi_data');
  appendElement(doiData, 'doi', doi);
  appendElement(doiData, 'resource', resourceUrl);
  return doiData;
}

export function buildIsbns(
  parent: Element,
  isbn: IsbnInputs | undefined,
  noIsbnReason?: NoIsbnReason
): void {
  const hasIsbn = isbn && (isbn.electronicIsbn || isbn.printIsbn);
  if (hasIsbn) {
    appendElementIf(parent, 'isbn', isbn.electronicIsbn, {
      media_type: 'electronic',
    });
    appendElementIf(parent, 'isbn', isbn.printIsbn, {
      media_type: 'print',
    });
  } else if (noIsbnReason) {
    appendElement(parent, 'noisbn', null, { reason: noIsbnReason });
  }
}

export function buildIssns(
  parent: Element,
  issn: IssnInputs | undefined
): void {
  if (!issn) return;
  appendElementIf(parent, 'issn', issn.onlineIssn, {
    media_type: 'electronic',
  });
  appendElementIf(parent, 'issn', issn.printIssn, {
    media_type: 'print',
  });
}

export function buildSimilarityCheck(
  parent: Element,
  url: string | undefined,
  emitEmpty = false
): void {
  if (!url) {
    if (emitEmpty) {
      appendElement(parent, 'collection', null, { property: 'crawler-based' });
    }
    return;
  }
  const collection = appendElement(parent, 'collection', null, {
    property: 'crawler-based',
  });
  const item = appendElement(collection, 'item', null, {
    crawler: 'similarity-check',
  });
  appendElement(item, 'resource', url);
}
